import { Component, Input, Output } from '@angular/core';
import { BaseComponent } from '../base-components/base-component.component';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-edit',
    template: `
        <div class="d-flex flex-row gap-1">
            <button 
                class="d-flex gap-2 align-items-center action-button edit-btn"
                (click)="onEditItem()"
            >
                <img class="icon" src="assets/icon/edit.png">
            </button>
        </div>
    `,
    styles: [
        `
            .icon {
                width: 24px;
                height: 24px;
                cursor: pointer;
            }
        `
    ]
})
export class EditComponent extends BaseComponent {

    @Output()
    emitter = new Subject<{ action: string, data: any }>();

    @Input()
    data: any = {};

    ngOnInit() {
    }

    onEditItem() {
        this.emitter.next({
            action: 'edit',
            data: this.data,
        });
    }
}
